'use client';
import { useEffect } from 'react';
import { sendGAEvent } from '@next/third-parties/google';

// Links that send a visitor to the app: the stores, the Kochava install links,
// and the web app.
const APP_LINK = /play\.google\.com|apps\.apple\.com|kochava|onelink|app\.dharmayana\.in/i;

// Records every click on an app link as a GA4 "app_cta_click" event, tagged with
// the page type and the link's place on the page, so installs can be traced back
// to the search pages that sent them. One listener covers every CTA component.
const AppCtaTracking = () => {
    useEffect(() => {
        const onClick = (event: MouseEvent) => {
            const link = (event.target as Element | null)?.closest?.('a[href]') as HTMLAnchorElement | null;
            if (!link || !APP_LINK.test(link.href)) return;
            sendGAEvent('event', 'app_cta_click', {
                page_type: window.location.pathname.split('/').filter(Boolean)[0] || 'home',
                page_path: window.location.pathname,
                link_host: new URL(link.href).hostname,
                link_section: link.closest('[id]')?.id || link.closest('section,footer,header,nav')?.tagName.toLowerCase() || 'page',
            });
        };
        document.addEventListener('click', onClick, { capture: true });
        return () => document.removeEventListener('click', onClick, { capture: true });
    }, []);
    return null;
};

export default AppCtaTracking;
